<template>
  <div>
    <base-title
      :title="'Detalhes do cupom'"
      :subtitle="StringLanguage.coupons"
      :link="'cupons'"
    >
      <span slot="tag" class="tag" v-if="!noPeriod"
        >{{ `Das ${formatDate(period[0])}, às ${formatDate(period[1])}` }}
        <i @click="setDefaultPeriod()" class="fal fa-times remove-filter"></i
      ></span>
      <base-button
        v-if="oCoupon.status === 'ACTIVE'"
        text="Pausar Cupom"
        @click="pauseCoupon"
        design="two"
        :class="!!isMobile && 'reverse mb_15 w-100'"
      />
      <base-button
        v-if="oCoupon.status === 'PAUSED'"
        text="Reativar Cupom"
        @click="ReativeCoupon"
        design="two"
        :class="!!isMobile && 'reverse mb_15 w-100'"
      />

      <base-button
        @click="drawers.filter.open = !drawers.filter.open"
        class="m_auto filter"
        :class="!!isMobile ? 'reverse w-100' : 'ml_20'"
        design="two"
      >
        <p class="filter" v-if="!isMobile">
          <i class="fal fa-calendar-day"></i>
        </p>
        <p class="filter" v-else>Filtrar período</p>
      </base-button>
    </base-title>

    <div class="row statistics">
      <div class="coupon-header-mobile mb_20">
        <div class="col-lg-4 col-md-12 col-xs-12" :class="!isMobile && 'pr_5'">
          <base-box class="m_0 no-shadow">
            <div class="ticket">
              <div class="ticket-dashed">
                <i class="mt_20 mb_10 ticket-icon fas fa-ticket-alt"></i>
                <p class="mb_20 coupon-code">{{ oCoupon.code }}</p>
              </div>
            </div>
            <div class="coupons-details">
              <div v-if="isCouponOnline" class="coupon-detail">
                <p>Grupo</p>
                <span>{{ campaignTarget }}</span>
              </div>
              <div v-if="isCouponOnline" class="coupon-detail">
                <p>Turno</p>
                <span>{{ campaignRunAt }}</span>
              </div>
              <div class="coupon-detail">
                <p>Benefício oferecido</p>
                <span>{{ couponValue }}</span>
              </div>
              <div class="coupon-detail">
                <p>Tipo do benefício</p>
                <span>{{ couponType }}</span>
              </div>
              <div class="coupon-detail">
                <p>Pedido mínimo</p>
                <span>{{ couponMinOrder }}</span>
              </div>
              <div class="coupon-detail">
                <p>Modo de uso</p>
                <span>{{ couponUseType }}</span>
              </div>
              <div class="coupon-detail">
                <p>Disponibilidade</p>
                <div class="d-flex align-center text-right">
                  <span>{{ availableDays }}&nbsp;</span>
                  <span v-if="availableHours">({{ availableHours }})</span>
                </div>
              </div>
              <div v-if="isCouponOnline" class="coupon-detail">
                <p>Data de envio</p>
                <span>{{ campaignDate }}</span>
              </div>
              <div class="coupon-detail">
                <p>Data de criação</p>
                <span>{{ couponCreatedAt }}</span>
              </div>
              <div class="coupon-detail">
                <p>Data de expiração</p>
                <span>{{ couponExpiration }}</span>
              </div>
              <div v-if="isCouponOnline" class="coupon-detail">
                <p>Custo</p>
                <span>{{ campaignCost }}</span>
              </div>
            </div>
          </base-box>
        </div>

        <div class="col-lg-8 col-md-12 col-xs-12">
          <coupon-funnel
            v-if="isCouponOnline"
            :results="results"
            :couponCode="couponCode"
            :campaign="campaign"
            :period="period"
          />

          <div v-else class="d-flex statistics-box">
            <base-box class="great-numbers mr_20 no-shadow">
              <div>
                <p>{{ results.total || 0 }}</p>
                <p>Total de usos</p>
              </div>
            </base-box>
            <base-box class="great-numbers mr_20">
              <div>
                <p>{{ Utils.convertMoney((results.sales || 0).toFixed(2)) }}</p>
                <p>Total em vendas</p>
              </div>
            </base-box>
            <base-box class="great-numbers">
              <div>
                <p>
                  {{ Utils.convertMoney((results.average || 0).toFixed(2)) }}
                </p>
                <p>Ticket Médio</p>
              </div>
            </base-box>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-md-12 col-xs-12">
        <chart-box
          class="chart no-shadow"
          :style="!isCouponOnline ? 'height: 465px' : 'height: 589px'"
          :reload-chart="reloadChart"
          :maskMoney="false"
          title="Usos por dia"
          type="line"
          :chartData="charData"
          :chartOptions="chartOptions"
        />
        <base-box class="msg-charts">
          <base-message>
            Para ver os gráficos disponíveis, vire seu celular em modo paisagem.
          </base-message>
        </base-box>
      </div>
    </div>

    <filter-period
      :open="drawers.filter.open"
      :close="drawers.filter.close"
      @filter="filterPeriod"
      :maxCustomRange="0"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import { DateTime } from 'easyjs/lib/Tools';
import Gift, { TYPE as aTypes, DivulgationType } from 'easyjs/lib/Schema/Gift';
import { CampaignType, CampaignRunAt } from 'easyjs/lib/Schema/Marketing';
import { isDayAvailable } from 'easyjs/lib/Schema/Availability';
import BaseTitle from '@/components/Title';
import BaseAdd from '@/components/Add';
import BaseBox from '@/components/Box';
import BaseButton from '@/components/Button';
import BaseDrawer from '@/components/Drawer';
import BaseMessage from '@/components/Message';

import FilterPeriod from '@/containers/FilterPeriod';
import ChartBox from '@/containers/ChartBox';
import CouponFunnel from '@/containers/Coupons/CouponsDivulgation';

import ApiReports from '@/api/reports';
import GiftAPI from '@/api/coupon';
import MarketingAPI from '@/api/marketing';

import Utils from '@/utils';

export default {
  data() {
    return {
      period: ['1900-01-01', dayjs().format('YYYY-MM-DD')],
      noPeriod: true,
      month: DateTime.format('m', new Date()),
      year: DateTime.format('Y', new Date()),
      day: 20,
      reloadChart: false,
      charData: {
        labels: [],
        datasets: [],
      },
      couponCode: null,
      oCoupon: Gift.fromObject({}),
      campaign: {},
      page: 0,
      results: {
        total: 0,
        sales: 0,
        average: 0,
      },
      drawers: {
        filter: {
          open: false,
          close: false,
        },
        publishForm: {
          open: false,
          close: false,
        },
      },
      Utils,
      datasetColors: {
        backgroundColor: '#2E3033',
        borderColor: '#FF3382',
        pointBackgroundColor: '#FF3382',
      },
      chartOptions: {
        maintainAspectRatio: false,
        responsive: true,
        height: 500,
        legend: {
          position: 'top',
          align: 'center',
          labels: {
            boxWidth: 20,
          },
        },
        elements: {
          line: {
            tension: 0,
            borderWidth: 1,
          },
        },
        scales: {
          xAxes: [
            {
              ticks: {
                maxTicksLimit: 10,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                min: 0,
                stepSize: 1,
              },
            },
          ],
        },
      },
    };
  },
  async created() {
    this.couponCode = this.$route.params.code;
    this.setDefaultPeriod();
    this.getCoupon().then(() => this.isCouponOnline && this.getCampaign());
  },
  methods: {
    getCoupon() {
      return GiftAPI.get(this.couponCode).then((response) => {
        if (response.getErrors([]).lengt > 0) {
          return alert(StringLanguage.loadError).then(() => {
            this.$router.push({ name: 'cupons' });
          });
        }

        this.oCoupon = Gift.fromObject(response.getData({}));
      });
    },
    getCampaign() {
      return MarketingAPI.campaignByGift(this.oCoupon.id).then((response) => {
        if (response.getErrors().length > 0) {
          return alert('Ocorreu um problema ao carregar os dados da campanha.');
        }

        this.campaign = response.getData({}).campaign;
      });
    },
    pauseCoupon() {
      const { code } = this.oCoupon;

      confirm(`Deseja mesmo pausar o cupom "${code}" ?`, (res) => {
        if (!res) return;
        return GiftAPI.pause(code).then((response) => {
          if (response.getErrors([]).lengt > 0) {
            return alert('Houve um problema ao pausar esse cupom.');
          }
          this.$router.push({ name: 'cupons' });
        });
      });
    },
    ReativeCoupon() {
      const { code, expiration } = this.oCoupon;
      const verifyExpiration = expiration || 999999999999;

      confirm(`Deseja mesmo Reativar o cupom "${code}" ?`, (res) => {
        if (!res) return;
        return GiftAPI.reactivate(code, verifyExpiration).then((response) => {
          if (response.getErrors([]).lengt > 0) {
            return alert('Houve um problema ao reativar esse cupom.');
          }

          this.$router.push({ name: 'cupons' });
        });
      });
    },

    formatDate(date) {
      const ds = date.split('T');
      return dayjs(dayjs(`${ds[0]} ${ds[1].split('-')[0]}`)).format(
        'HH:mm [de] DD/MM/YYYY'
      );
    },
    setDefaultPeriod() {
      const filter = {
        type: 2,
        periods: [
          `1970-01-01`,
          `${this.year}-${this.month}-${DateTime.format(
            'd',
            DateTime.lastDayOfMonth(this.year, parseInt(this.month) - 1)
          )} 23:59:59`,
        ],
      };

      this.filterPeriod(filter, true);
    },
    filterPeriod(filter, isPeriodDefault = false) {
      this.filterType = parseInt(filter.type, 10);
      this.period = filter.periods;
      this.noPeriod = !!isPeriodDefault;

      filter.periods[0] = dayjs(filter.periods[0]).format(
        'YYYY-MM-DDTHH:mm:ssZ[Z]'
      );
      filter.periods[1] = dayjs(filter.periods[1]).format(
        'YYYY-MM-DDTHH:mm:ssZ[Z]'
      );

      this.getCouponPeriod(filter);

      this.drawers.filter.close = !this.drawers.filter.close;
    },
    getCouponPeriod(filter) {
      let type = 'day';
      switch (parseInt(filter.type)) {
        case 1:
          type = 'hour';
          break;
        case 2:
          type = 'day';
          break;
        case 3:
          type = 'month';
          break;
        default:
          type = 'day';
      }

      const esFilter = {
        query: [
          {
            index: 'report-orders',
            type: 'aggs',
            queries: [
              {
                query_string: {
                  query: `${this.couponCode}`,
                  fields: ['gift.code'],
                },
              },
              {
                bool: {
                  should: [
                    {
                      match: {
                        status: 4,
                      },
                    },
                    {
                      match: {
                        status: -1,
                      },
                    },
                  ],
                },
              },
            ],
            aggs: {
              couponUse: {
                date_range: {
                  field: 'created_at',
                  ranges: [
                    {
                      from: filter.periods[0],
                      to: filter.periods[1],
                    },
                  ],
                },
                aggs: {
                  uses_over_time: {
                    date_histogram: {
                      field: 'created_at',
                      interval: type,
                      min_doc_count: 1,
                    },
                    aggs: {
                      total: {
                        sum: {
                          field: 'total_amount',
                        },
                      },
                    },
                  },
                  total: {
                    nested: {
                      path: 'payers',
                    },
                    aggs: {
                      total: {
                        sum: {
                          field: 'payers.amount',
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        ],
      };

      ApiReports.reports(esFilter).then((response) => {
        const bucket = response.data[0].couponUse.buckets[0];

        this.results.total = bucket.total.doc_count;
        this.results.sales = bucket.total.total.value;
        this.results.average = this.results.sales / this.results.total;

        const usesOverTime = bucket.uses_over_time.buckets.map((item) => {
          return {
            date: item.key,
            date_as_string: item.key_as_string,
            qty: item.doc_count,
            value: item.total.value,
          };
        });

        this.setChartData(usesOverTime, bucket.from, bucket.to);
      });
    },
    setChartData(data, from, to) {
      this.charData.datasets = [];
      this.charData.labels = [];

      let label =
        this.filterType === 2
          ? dayjs(to).format('MMMM/YY')
          : dayjs(to).format('YYYY');

      const labelChart = [];
      const dataChart = [];

      const limit = this.filterType === 2 ? dayjs(to).daysInMonth() : 12;

      for (let i = 1; i <= limit; i++) {
        labelChart.push(
          this.filterType === 2 ? `Dia ${i}` : Utils.getMonthNames(i)
        );
        dataChart.push(0);
      }

      const currentMonth = dayjs(to).month();

      let dataBelongToCurrentMonth = false;
      let qtyCurrentMonth = 0;

      data.forEach((item) => {
        if ([1, 4, 5].indexOf(this.filterType) !== -1) {
          const monthIdx = parseInt(dayjs(item.date).format('M'), 10) - 1;
          dataChart[monthIdx] += parseInt(item.qty || 0, 10);
        }

        if (this.filterType === 2) {
          const itemMonth = dayjs(item.date).month();
          const dayIdx = dayjs(item.date).add(3, 'hour').format('D') - 1;
          dataChart[dayIdx] =
            itemMonth === currentMonth ? parseInt(item.qty || 0, 10) : 0;

          dataBelongToCurrentMonth = itemMonth === currentMonth;
          if (dataBelongToCurrentMonth) qtyCurrentMonth = item.qty;
        }

        if (this.filterType === 3) {
          const monthIdx = parseInt(dayjs(item.date).format('M'), 10);
          dataChart[monthIdx] = parseInt(item.qty || 0, 10);
        }
      });

      label += this.noPeriod
        ? ` (${qtyCurrentMonth})`
        : ` (${this.results.total})`;

      const newDataset = {
        label,
        backgroundColor: this.datasetColors.backgroundColor,
        borderColor: this.datasetColors.borderColor,
        pointBackgroundColor: this.datasetColors.borderColor,
        data: dataChart,
      };

      this.charData.datasets.push(newDataset);
      this.charData.labels = labelChart;
      this.reloadChart = !this.reloadChart;
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
      screenWidth: (state) => state.store.screenWidth,
    }),
    isCouponOnline() {
      return this.oCoupon.divulgation === DivulgationType.ONLINE;
    },
    couponType() {
      if (this.oCoupon.typeIs(aTypes.DELIVERY)) {
        return 'Entrega Grátis';
      }

      if (this.oCoupon.typeIs(aTypes.PERCENT)) {
        return `Desconto em %`;
      }

      if (this.oCoupon.typeIs(aTypes.PRICE)) {
        return 'Desconto em R$';
      }
    },
    couponValue() {
      if (this.oCoupon.typeIs(aTypes.DELIVERY)) {
        return '---';
      }

      if (this.oCoupon.typeIs(aTypes.PERCENT)) {
        return `${this.oCoupon.value}%`;
      }

      if (this.oCoupon.typeIs(aTypes.PRICE)) {
        return Utils.convertMoney(this.oCoupon.value, 'R$', '');
      }
    },
    couponUseType() {
      if (this.oCoupon.typeIs(aTypes.FREE_TO_USE)) {
        return 'Usos ilimitados por cadastro';
      }

      if (this.oCoupon.typeIs(aTypes.N_USE)) {
        return 'Uso único por cadastro';
      }
    },
    couponMinOrder() {
      return Utils.convertMoney(this.oCoupon.min_order);
    },
    couponCreatedAt() {
      return dayjs(this.oCoupon.created_at).utc().format('DD/MM/YYYY');
    },
    couponExpiration() {
      return this.oCoupon.expiration
        ? Utils.ts2Date(this.oCoupon.expiration, false)
        : '---';
    },
    campaignTarget() {
      switch (this.campaign.alias) {
        case CampaignType.LAST15DAYS:
          return 'Não pedem a 15 dias';
        default:
          return 'Toda a base';
      }
    },
    campaignRunAt() {
      switch (this.campaign.run_at) {
        case CampaignRunAt.LUNCH:
          return 'Almoço';
        case CampaignRunAt.BREAKFAST:
          return 'Café';
        case CampaignRunAt.DINNER:
          return 'Jantar';
      }
    },
    campaignDate() {
      return dayjs(this.campaign.date).utc().format('DD/MM/YYYY');
    },
    campaignCost() {
      return Utils.convertMoney(0);
    },
    availableDays() {
      if (!this.oCoupon.availability) {
        return `Sempre disponível`;
      }

      const days = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'];

      let result = '';
      days.forEach((day, index) => {
        if (isDayAvailable(this.oCoupon.availability.daysOfTheWeek, index)) {
          result += `${day}, `;
        }
      });

      return result.slice(0, result.length - 2);
    },
    availableHours() {
      if (
        !this.oCoupon.availability ||
        this.oCoupon.availability.periods.length === 0
      ) {
        return null;
      }

      let hours = '';
      this.oCoupon.availability.periods.forEach((period) => {
        hours += `${period.beginTime} - ${period.endTime}, `;
      });

      return hours.slice(0, hours.length - 2);
    },
  },
  components: {
    BaseTitle,
    BaseAdd,
    BaseBox,
    BaseButton,
    BaseDrawer,
    BaseMessage,
    FilterPeriod,
    ChartBox,
    CouponFunnel,
  },
};
</script>
<style scoped>
.tag {
  background: rgba(128, 128, 128, 0.2);
  padding: 4px 12px;
  margin-left: 10px;
  font: normal normal bold 1.2em Lato;
  color: #999;
  border-radius: 5px;
}
.remove-filter {
  margin-left: 12px;
  font-size: 13px;
  cursor: pointer;
}
.statistics {
  margin-bottom: 5px;
}
.ticket {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: var(--background);
  border-radius: 5px;
  margin-bottom: 15px;
  padding: 20px 0;
}
.ticket-dashed {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 90%;
  border-top: 2px dashed #6c6c6c;
  border-bottom: 2px dashed #6c6c6c;
}
.ticket-icon {
  color: var(--label-secondary);
  font-size: 2.5em;
}
.coupon-code {
  font-size: 1.8em;
  font-weight: bold;
  color: var(--label-secondary);
  line-height: 22px;
}
.coupons-details {
  max-height: calc(100% - 70px);
}
.coupons-details::-webkit-scrollbar {
  width: 5px;
}
.coupons-details::-webkit-scrollbar-track {
  background: #fafafa;
}
.coupons-details::-webkit-scrollbar-thumb {
  background: #e6e6e6;
}
.coupon-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.4em;
  color: #999999;
  padding: 20px 0;
  border-top: 1px solid #3f4146;
}
.coupon-detail span {
  color: #bbb;
}
.coupon-detail:first-child {
  border-top: none;
}
.great-numbers {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  margin-bottom: 20px;
}
.great-numbers div p:first-child {
  color: var(--default);
  font-size: 2.3em;
  line-height: 28px;
  font-weight: 900;
  text-align: center;
}
.great-numbers div p:last-child {
  color: #999;
  margin-top: 15px;
  font-size: 1.2em;
  text-align: center;
}
.msg-charts {
  display: none;
}
.divulgations-header {
  display: flex;
  align-items: baseline;
  margin-bottom: 35px;
}
.divulgations-header h1 {
  font: normal normal normal 2em Rubik;
  color: #001f33;
  opacity: 0.6;
}

@media screen and (max-width: 991px) {
  @media screen and (orientation: portrait) {
    .chart {
      opacity: 0;
      position: absolute;
      top: 0;
      width: 0;
      overflow: hidden;
    }
    .msg-charts {
      display: block;
    }
  }
  .great-numbers div p:first-child {
    line-height: initial;
  }
  .great-numbers div p:last-child {
    text-transform: initial;
  }
  .statistics-box .great-numbers:first-child > div {
    flex: 0 100%;
    text-align: center;
  }

  .statistics-box .great-numbers > div {
    text-align: center;
  }

  .statistics-box .great-numbers:first-child > div.icon {
    position: absolute;
    right: 30px;
  }
  .ticket {
    margin-bottom: 20px;
  }
  .great-numbers {
    margin-bottom: 15px;
  }
  .great-numbers div p:last-child {
    margin-top: 5px;
  }
  .great-numbers:nth-child(2) {
    margin-right: 15px;
  }
  .coupon-code {
    font-size: 1.4em;
  }
  .ticket-icon {
    font-size: 1.8em;
  }
  .coupon-detail {
    font-size: 1.2em;
  }

  .statistics {
    margin-bottom: 0px;
  }
  .coupon-header-mobile {
    display: flex;
    flex-direction: column-reverse;
  }
  .statistics-box {
    display: flex !important;
    flex-wrap: wrap;
    margin-top: 5px;
  }
  .statistics-box .great-numbers:first-child {
    margin-right: 0;
  }
  .statistics-box > .great-numbers:not(:first-child) {
    flex: 1 1;
  }
  .great-numbers .icon {
    width: 23px;
    height: 23px;
    font-size: 1.2em;
  }
  .great-numbers div p:first-child {
    font-size: 1.5em;
  }
  .great-numbers div p:last-child {
    font-size: 1em;
  }
  .divulgations-header {
    margin-bottom: 25px;
  }
}
</style>
